/* eslint-disable max-statements */
import React, { useEffect } from "react";
import PropTypes from "prop-types";

import Cars24CoverRevamp from "../cars24-cover-revamp";
import { AB_TEST_VARIATIONS, SERVICING_VARIANT_MAPPING } from "../../../constants/app-constants";
import { trackDesktopCustomEventsAU } from "../../../tracking";
import { PLATINUM_COVER_GA_EVENTS } from "../cars24-cover-revamp/tracking";
import { getIsNewServicingVariant } from "../../../utils/statsig-ab-utils/get-experiment-data";
import Cars24CoverPitching from "../cars24-cover-pitching";
import LoaderScreen from "../loader-screen/component";
import { VAS_CATEGORY_KEYS } from "../../../constants/checkout-constants";

const Cars24CoverWrapper = (props) => {
    const { servicingPriceConfig, desktopProductPitching,   content = {},
        order,
        getServicingPriceConfigConnect } = props;

    const  { orderId, deliveryAddress, pickUpAddress } = order;
    const isServicingConfigLoading = servicingPriceConfig?.loading;
    const isNewServicingVariant = getIsNewServicingVariant(servicingPriceConfig?.data?.experiment);
    const isNewPitchingVariant = desktopProductPitching?.data === AB_TEST_VARIATIONS.VARIANT_B;
    const screenType = servicingPriceConfig?.data?.metadataKey;

    const showNewPitchingVariant = screenType === VAS_CATEGORY_KEYS.CAR_SERVICING || screenType === VAS_CATEGORY_KEYS.WARRANTY || isNewPitchingVariant || !isNewServicingVariant;

    const getBundleVariant = async () => {
        const pincode = deliveryAddress?.pincode || pickUpAddress?.pincode;
        const experimentType = SERVICING_VARIANT_MAPPING.VARIANT;
        await getServicingPriceConfigConnect(content?.appointmentId, pincode, experimentType);
    };

    useEffect(() => {
        if (orderId) {
            getBundleVariant();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [orderId]);

    useEffect(() => {
        if (desktopProductPitching?.data) {
            const gaPitchingEventLabel = PLATINUM_COVER_GA_EVENTS.CARS24_COVER_PITCHING_VARIANT.eventLabel.replace(
                "variant",
                isNewPitchingVariant ? "Variant B" : "Variant A"
            );
            trackDesktopCustomEventsAU("", {
                ...PLATINUM_COVER_GA_EVENTS.CARS24_COVER_PITCHING_VARIANT,
                eventLabel: gaPitchingEventLabel
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [desktopProductPitching?.data]);

    useEffect(() => {
        if (screenType) {
            trackDesktopCustomEventsAU("", {
                ...PLATINUM_COVER_GA_EVENTS.CARS24_COVER_PRODUCT_NAME,
                eventLabel: screenType
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [screenType]);

    if (isServicingConfigLoading) {
        return <LoaderScreen />;
    } else if (showNewPitchingVariant) {
        return <Cars24CoverPitching {...props} screenType={screenType} />;
    } else if (isNewServicingVariant) {
        return <Cars24CoverRevamp {...props} />;
    } else {
        return <LoaderScreen />;
    }
};

Cars24CoverWrapper.propTypes = {
    warrantyPlanInfo: PropTypes.object,
    manufacturerWarranty: PropTypes.object,
    content: PropTypes.object,
    servicingPriceConfig: PropTypes.object,
    desktopProductPitching: PropTypes.object,
    order: PropTypes.object,
    getServicingPriceConfigConnect: PropTypes.func
};

export default Cars24CoverWrapper;
